<template>
    <div>
        <div class="bg-white shadow overflow-hidden  sm:rounded-lg">
            <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Customer Order Settings
                </h3>
            </div>
            <div class="px-4 py-5 sm:p-0">
                <form @submit.prevent="submit">
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Accepts orders
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <toggle v-model="form.config.accept_orders" />
                            <div class="text-normal inline ml-4">
                                <span v-if="form.config.accept_orders">When enabled, customers can place orders.</span>
                                <span v-else>When disabled, customers cannot place any orders.</span>
                            </div>
                        </dd>
                    </div>

                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5" v-if="form.config.accept_orders">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Order accepting time window
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <text-input v-model="form.config.day_start_time" type="time" :errors="$page.props.errors['config.day_start_time']" class="pr-6 pb-8 w-25" label="Opening Time"/>
                            <text-input v-model="form.config.day_closing_time" type="time" :errors="$page.props.errors['config.day_closing_time']" class="pr-6 pb-8 w-25" label="Closing Time"/>
                        </dd>
                    </div>

                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                           Working Weekdays
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <div>
                                <table>
                                    <tr>
                                        <th class="px-2 text-gray-600">Sun</th>
                                        <th class="px-2 text-gray-600">Mon</th>
                                        <th class="px-2 text-gray-600">Tue</th>
                                        <th class="px-2 text-gray-600">Wed</th>
                                        <th class="px-2 text-gray-600">Thu</th>
                                        <th class="px-2 text-gray-600">Fri</th>
                                        <th class="px-2 text-gray-600">Sat</th>
                                    </tr>
                                    <tr>
                                        <td class="px-2"><input type="checkbox" v-model="form.config.working_weekdays.sun" class="form-check"></td>
                                        <td class="px-2"><input type="checkbox" v-model="form.config.working_weekdays.mon" class="form-check"></td>
                                        <td class="px-2"><input type="checkbox" v-model="form.config.working_weekdays.tue" class="form-check"></td>
                                        <td class="px-2"><input type="checkbox" v-model="form.config.working_weekdays.wed" class="form-check"></td>
                                        <td class="px-2"><input type="checkbox" v-model="form.config.working_weekdays.thu" class="form-check"></td>
                                        <td class="px-2"><input type="checkbox" v-model="form.config.working_weekdays.fri" class="form-check"></td>
                                        <td class="px-2"><input type="checkbox" v-model="form.config.working_weekdays.sat" class="form-check"></td>
                                    </tr>
                                </table>
                                <div>
                                    <p class="text-sm text-gray-400">Note: Only used for selecting the weekday for customer to place order. This doesn't restrict a customer from placing an order on a none working day.</p>
                                </div>
                            </div>
                        </dd>
                    </div>

                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Delivery service
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <toggle v-model="form.config.delivery_service" />
                            <div class="text-normal inline ml-4">
                                <span v-if="form.config.delivery_service">Delivery service option is enabled.</span>
                                <span v-else>Delivery service option is disabled.</span>
                            </div>
                        </dd>
                    </div>


                  <div v-if="form.config.delivery_service" class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                      Delivery Service Settings
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                        <table>
                            <thead>
                              <th class="px-3">Location</th>
                              <th class="px-3">Enable</th>
                              <th class="px-3">Daily Limit</th>
                              <th class="px-3">Location Type</th>
                            </thead>
                          <tbody>
                              <tr v-for="(delivery, dKey) in form.config.delivery_locations" :key="dKey">
                                <td class="px-3">{{ delivery.label }}</td>
                                <td class="px-3 text-center"><input type="checkbox" v-model="delivery.enable" class="form-check"></td>
                                <td class="px-3 text-center"><text-input v-model="delivery.daily_limit" type="number" :errors="$page.props.errors.delivery_locations && $page.props.errors.delivery_locations[$dKey].limit" class="w-12" /></td>
                                <td class="px-3">
                                  <select v-model="delivery.location_type" class="form-input">
                                    <option value="address">Address Location</option>
                                    <option value="vessel_location">Vessel Location</option>
                                  </select>
                                </td>
                              </tr>
                          </tbody>
                        </table>
                    </dd>
                  </div>

                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Allow selection of product units
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <toggle v-model="form.config.allow_product_unit_selection" />
                            <div class="text-normal inline ml-4">
                                <span>Customers can choose available product unit types</span>
                            </div>
                        </dd>
                    </div>

                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Display Item Price
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <toggle v-model="form.config.display_item_price"/>
                            <div class="text-normal inline ml-4">
                                Show item price on the catalogue list
                            </div>
                        </dd>
                    </div>

                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Limit new orders from Customer
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                          <div class="text-normal inline ml-4">
                            Restrict new orders if any pending orders
                          </div>
                            <div class="w-full">

                              <table class="table w-full">
                                <tr>
                                  <th class="text-left">Basic Customer</th>
                                  <th class="text-left">Special Customer</th>
                                </tr>
                                <tr>
                                  <td><toggle v-model="form.config.new_order_restrict_on_pending_count"/></td>
                                  <td><toggle v-model="form.config.new_order_restrict_on_pending_count_special_customer"/></td>
                                </tr>
                              </table>

                            </div>
                        </dd>
                    </div>


                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Daily limits
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <toggle v-model="form.config.daily_limit_enable" />
                            <div class="text-normal inline ml-4">
                                <span v-if="form.config.daily_limit_enable">Enable options to control order capacity</span>
                                <span v-else>When disabled, there is no limitation.</span>
                            </div>
                        </dd>
                    </div>

                    <div v-if="form.config.daily_limit_enable" class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Total number of orders accepted per day
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">

                          <div>
                            <select v-model="form.config.daily_limit_type" class="form-input">
                              <option value="global">Global Limit</option>
                              <option value="custom">Custom Limit by Location</option>
                            </select>
                          </div>

                          <div v-if="form.config.daily_limit_type === 'global'" class="mt-2">
                            <p>Global limit:</p>
                            <text-input v-model="form.config.daily_max_orders" type="number" :errors="$page.props.errors.daily_max_orders" class="pr-6 pb-8 w-25" />
                          </div>
                          <div v-if="form.config.daily_limit_type === 'custom'" class="mt-2">
                            <p>Configure location specific custom limit:</p>
                            <table>
                                <tr>
                                  <th class="px-3 text-left">Male'</th>
                                  <td class="px-3"><text-input v-model="form.config.daily_max_orders_male" type="number" class="w-12" /></td>
                                </tr>
                                <tr>
                                  <th class="px-3 text-left">Hulhumale</th>
                                  <td class="px-3"><text-input v-model="form.config.daily_max_orders_hulhumale" type="number" class="w-12" /></td>
                                </tr>
                                <tr>
                                  <th class="px-3 text-left">Island</th>
                                  <td class="px-3"><text-input v-model="form.config.daily_max_orders_island" type="number" class="w-12" /></td>
                                </tr>
                            </table>

                          </div>

                        </dd>
                    </div>

                    <div v-if="form.config.daily_limit_enable" class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Total number of orders per customer per day
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <table>
                              <tr>
                                <th class="text-left">Basic Customer</th>
                                <th class="text-left">Special Customer</th>
                              </tr>
                              <tr>
                                <td><text-input v-model="form.config.per_customer_daily_order_limit" type="number" :errors="$page.props.errors.per_customer_daily_order_limit" class="pr-6 pb-8 w-25" /></td>
                                <td><text-input v-model="form.config.per_special_customer_daily_order_limit" type="number" :errors="$page.props.errors.per_special_customer_daily_order_limit" class="pr-6 pb-8 w-25" /></td>
                              </tr>
                            </table>

                        </dd>
                    </div>

                  <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                      Enable Payment Reminder (SMS)
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                      <toggle v-model="form.config.enable_payment_reminder"/>
                      <div class="text-normal inline ml-4">
                        <p>When enabled, daily at 8am an SMS reminder will be sent to orders in quoted status for more than 2 days</p>
                      </div>
                    </dd>
                  </div>

                  <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                      Enable Collection Reminder (SMS)
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                      <toggle v-model="form.config.enable_collection_reminder"/>
                      <div class="text-normal inline ml-4">
                        <p>When enabled, daily at 8:15am an SMS reminder will be sent to orders ready for customer collection in invoiced status for more than 2 days</p>
                      </div>
                    </dd>
                  </div>


                    <div v-if="form.config.daily_limit_enable" class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Enable Tawk.to Chat widget
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <toggle v-model="form.config.tawkto_enable"/>
                            <div class="text-normal inline ml-4">
                                <p>When enabled, chat widget will be available on customer logins</p>
                            </div>
                        </dd>
                    </div>

                    <div v-if="form.config.daily_limit_enable" class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                          Enable inventory check
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <toggle v-model="form.config.enable_inventory_check"/>
                            <div class="text-normal inline ml-4">
                                <span>Only items available from stock can be placed into an order</span>
                            </div>
                        </dd>
                    </div>

                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                          Enable Auto Inactive for Out of Stock
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                            <toggle v-model="form.config.enable_auto_inactive_out_of_stock"/>
                            <div class="text-normal inline ml-4">
                                <span>Automatically Inactivate Out of Stock Products. Checked Hourly.</span>
                            </div>
                        </dd>
                    </div>

                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                      <dt class="text-sm leading-5 font-medium text-gray-500">
                        SMS Sender
                      </dt>
                      <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 flex items-center">
                        <select v-model="form.config.sms_driver" class="form-select">
                          <option value="log">None</option>
                          <option value="msgowl">MsgOwl</option>
                          <option value="aws">AWS SNS</option>
                        </select>

                      </dd>
                    </div>




                    <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            System Messages
                        </h3>

                        <div class="mt-4">
                            <textarea-input v-model="form.messages.not_accepting_orders" label="Message to show when not accepting orders"></textarea-input>
                        </div>

                        <div class="mt-4">
                            <textarea-input v-model="form.messages.order_limit_reached" label="Message to show when order limit is reached"></textarea-input>
                        </div>
                    </div>


                    <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Terms & Conditions
                        </h3>

                        <div class="mt-4">
                            <wysiwyg v-model="form.config.terms_conditions" />
                        </div>
                    </div>


                    <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
                        <loading-button :loading="sending" class="btn-primary" type="submit">Update Settings</loading-button>
                    </div>


                </form>
            </div>


        </div>
    </div>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'
  import Toggle from '@/Shared/Toggle'
  import Icon from '@/Shared/Icon'
  import LoadingButton from '@/Shared/LoadingButton'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'
  import TextareaInput from '@/Shared/TextareaInput'

  export default {
    metaInfo: { title: 'Settings' },
    layout: Layout,
    components: {
      Icon,
      LoadingButton,
      SelectInput,
      TextInput,
      Toggle,
      TextareaInput
    },

    props: {
      config: Object,
      messages: Object,
      options: Object
    },

    data() {
      return {
        sending: false,
        form: {
          config: {
            accept_orders: this.config.accept_orders,
            day_start_time: this.config.day_start_time,
            day_closing_time: this.config.day_closing_time,
            delivery_service: this.config.delivery_service,
            delivery_locations: this.config.delivery_locations,
            allow_product_unit_selection: this.config.allow_product_unit_selection,
            daily_limit_enable: this.config.daily_limit_enable,
            daily_limit_type: this.config.daily_limit_type,
            per_customer_daily_order_limit: this.config.per_customer_daily_order_limit,
            per_special_customer_daily_order_limit: this.config.per_special_customer_daily_order_limit,
            new_order_restrict_on_pending_count_special_customer: this.config.new_order_restrict_on_pending_count_special_customer,
            daily_max_orders: this.config.daily_max_orders,
            daily_max_orders_male: this.config.daily_max_orders_male,
            daily_max_orders_hulhumale: this.config.daily_max_orders_hulhumale,
            daily_max_orders_island: this.config.daily_max_orders_island,
            enable_inventory_check: this.config.enable_inventory_check,
            enable_payment_reminder: this.config.enable_payment_reminder,
            enable_auto_inactive_out_of_stock: this.config.enable_auto_inactive_out_of_stock,
            terms_conditions: this.config.terms_conditions,
            display_item_price: this.config.display_item_price,
            working_weekdays: this.config.working_weekdays,
            new_order_restrict_on_pending_count: this.config.new_order_restrict_on_pending_count,
            tawkto_enable: this.config.tawkto_enable,
            sms_driver: this.config.sms_driver,
          },
          messages: {
            not_accepting_orders: this.messages.not_accepting_orders,
            order_limit_reached: this.messages.order_limit_reached
          }
        }
      }
    },

    methods: {
      submit() {
        this.sending = true
        this.$inertia.post(this.route('admin.settings.update'), this.form, {
          onFinish: () => this.sending = false
        })
      }
    }
  }
</script>
